var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_56_copy",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "40.475 88.871 49.029 88.871 59.416 88.871" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "50.056 88.874 50.056 88.864 50.056 82.794" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "59.643 88.868 51.089 88.868 40.701 88.868" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50.056", y1: "88.864", x2: "50.056", y2: "82.794" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m69.099,12.405c-4.372-4.372-11.461-4.372-15.833,0-2.273,2.273-3.354,5.281-3.263,8.26h9.583c.57,0,1.03.49.99,1.06l-.97,16.73.406-7.003c3.242.339,6.602-.73,9.087-3.214,4.372-4.372,4.372-11.461,0-15.833Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m55.986,74.414c-1.77.63-3.26,1.78-4.3,3.25-1.03,1.46-1.63,3.24-1.63,5.13,0-1.89-.59-3.67-1.63-5.13-1.03-1.47-2.51-2.62-4.29-3.25-5.18-1.83-8.16-7.25-6.94-12.61l2.3-10.5c.92-4.22,1.26-8.54,1.01-12.85l-.97-16.73c-.03-.57.42-1.06,1-1.06h19.05c.57,0,1.03.49.99,1.06l-.97,16.73c-.25,4.31.09,8.63,1.02,12.85l2.29,10.5c1.23,5.35-1.75,10.78-6.93,12.61Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "66.311", y1: "15.192", x2: "64.29", y2: "17.213" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "61.182", y1: "13.068", x2: "61.182", y2: "15.926" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "56.053", y1: "15.192", x2: "58.074", y2: "17.213" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "68.435", y1: "20.321", x2: "65.578", y2: "20.321" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "66.311", y1: "25.45", x2: "64.29", y2: "23.429" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m40.527,35.86l1.926.712c2.724,1.007,5.77.596,8.129-1.099h0c2.221-1.596,5.062-2.06,7.676-1.253l1.043.322",
        },
      }),
      _c("circle", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { cx: "46.008", cy: "46.841", r: "1.6" },
      }),
      _c("circle", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { cx: "53.023", cy: "41.89", r: "1.6" },
      }),
      _c("circle", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { cx: "44.473", cy: "65.333", r: "1.6" },
      }),
      _c("circle", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { cx: "50.058", cy: "56.939", r: "1.6" },
      }),
      _c("circle", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { cx: "55.424", cy: "68.057", r: "1.6" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }